﻿import bundledJQuery from 'jquery';
import 'jquery-mask-plugin';
import '../less/page-18.less';
import Webcam from './lib/webcam-capture';

// Sync jQuery plugins from bundled jQuery to window.jQuery.
if (window.jQuery && window.jQuery !== bundledJQuery) {
    Object.keys(bundledJQuery.fn).forEach(function (key) {
        if (!window.jQuery.fn[key]) {
            window.jQuery.fn[key] = bundledJQuery.fn[key];
        }
    });
    Object.keys(bundledJQuery).forEach(function (key) {
        if (typeof bundledJQuery[key] === 'function' && !window.jQuery[key]) {
            window.jQuery[key] = bundledJQuery[key];
        }
    });
}

const jQuery = window.jQuery;

(function ($) {
    function Page18YearsScrips() {
        const body = $('body');
        const wind = $(window);
        const self = this;

        const form = $('#uploadDoc18Form');
        const form_submit = $('#doc18Submit');
        const file_input = $('#uploadDoc18Input');
        const file_name = $('#uploadDoc18Filename');
        const webcam_btn = $('#webcamDoc18');
        const webcam_btn_sub = $('#webcamDoc18Submit');
        const webcam_btn_canc = $('#webcamDoc18Cancel');
        const webcam_html = $('#webcamDoc18HTML');
        const webcam_html_cont = $('#webcamDoc18HTMLCont');
        const message_box = $('#uploadDoc18Msg');
        const uploadFileMaxSize = 3000;
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

        let webcam_val = false;

        function initWebcamBtn() {
            if (!webcam_btn) {
                return false;
            }
            Webcam.set({
                image_format: 'jpeg',
                jpeg_quality: 90,
                force_flash: false,
                width: 600,
                height: 440,
            });
            webcam_btn.on('click', function () {
                Webcam.reset();
                webcam_html.addClass('is-active');
                webcam_html_cont.html('<div id="camera" style="margin: auto;"></div>');
                Webcam.attach('#camera');
            });
            webcam_btn_canc.on('click', function () {
                Webcam.reset();
                webcam_html.removeClass('is-active');
                webcam_html_cont.html('');
            });
            webcam_btn_sub.on('click', function () {
                Webcam.snap(function (data_uri) {
                    webcam_val = data_uri;
                    file_name.text('web-camera.jpg');
                    Webcam.reset();
                    webcam_html.removeClass('is-active');
                    webcam_html_cont.html('');
                    $('#uploadDoc18ImgType').val('webcam');
                });
            });
        }

        function initUploadBtn() {
            file_input.on('change', function () {
                let validate_file = validateFile();
                if (!validate_file.is_valid) {
                    file_input.next('.wupload_error').text(validate_file.error);
                    form_submit.attr('disabled', 'disabled');
                } else {
                    file_input.next('.wupload_error').text('');
                    file_name.text(file_input[0].files[0].name);
                    webcam_val = false;
                    form_submit.removeAttr('disabled');
                }
                $('#uploadDoc18ImgType').val('form');
            });
        }

        function clearForm() {
            form.removeClass('active');
            file_name.text('');
        }

        function validateFile() {
            let result = {
                is_valid: true,
                error: '',
            };
            if (!file_input.val()) {
                result.is_valid = false;
                result.error = p18s.error_empty_file;
                return result;
            }
            let file = file_input[0].files[0];
            let fileSize = Math.round(file.size / 1024);
            if (!validImageTypes.includes(file.type)) {
                result.is_valid = false;
                result.error = p18s.error_invalid_file_type;
                return result;
            }
            if (fileSize > uploadFileMaxSize) {
                result.is_valid = false;
                result.error = p18s.error_too_large;
                return result;
            }
            return result;
        }

        function renderMessage(txt, cls) {
            let box = `
                <div class="alert ${cls}" role="alert">
                    ${txt}
                </div>
            `;
            message_box.html('').append(box);
        }

        function validateForm() {
            let form_is_valide = true;
            $('.wupload_validate').each(function () {
                if (!$(this).val()) {
                    $(this).addClass('wupload_validate_error');
                    $(this).next('.wupload_error').text(p18s.validate_req);
                    form_is_valide = false;
                } else {
                    $(this).removeClass('wupload_validate_error');
                    $(this).next('.wupload_error').text('');
                }
                if ($(this).attr('type') == 'email') {
                    if (!isEmail($(this).val())) {
                        $(this).addClass('wupload_validate_error');
                        $(this).next('.wupload_error').text(p18s.validate_email);
                        form_is_valide = false;
                    } else {
                        $(this).removeClass('wupload_validate_error');
                        $(this).next('.wupload_error').text('');
                    }
                }
            });
            return form_is_valide;
        }

        function isEmail(email) {
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        }

        function initFormInputs() {
            $('.wupload_validate').on('change', function () {
                $(this).removeClass('wupload_validate_error');
                $(this).next('.wupload_error').text('');
            });
        }

        function initFormMask() {
            let inputTel = jQuery('#wupload_phone');
            if (inputTel) {
                inputTel.mask('(000) 000 00 00');
            }
            let inputPostcode = jQuery('#wupload_p_index');
            if (inputPostcode) {
                inputPostcode.mask('0#');
            }
        }

        function initFormSubmit() {
            form.submit(function (e) {
                e.preventDefault();
                let reader = new FormData();
                if (webcam_val) {
                    reader.append('file_data', webcam_val);
                } else {
                    let validate_file = validateFile();
                    if (!validate_file.is_valid) {
                        file_input.next('.wupload_error').text(validate_file.error);
                        return false;
                    }
                    let validate_form = validateForm();
                    if (!validate_form) {
                        return false;
                    }
                    reader.append('file_data', file_input[0].files[0]);
                }
                let form_data = $('form').serializeArray();
                form_data.forEach(function (it) {
                    reader.append(it.name, it.value);
                });
                $.ajax({
                    url: twf.ajax_url,
                    type: 'POST',
                    data: reader,
                    cache: false,
                    dataType: 'json',
                    processData: false,
                    contentType: false,
                    beforeSend: function (response) {
                        window.window.jQuery.LoadingOverlay('show');
                    },
                    complete: function (response) {
                        window.window.jQuery.LoadingOverlay('hide');
                    },
                    success: function (response) {
                        if (response.success) {
                            form[0].reset();
                            file_name.text('');
                            $('#uploadDoc18 .close').click();
                            $('#uploadDoc18FinBtn').click();
                        } else {
                            renderMessage(response.data, 'alert-danger');
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        renderMessage(p18s.error_server, 'alert-danger');
                    },
                });
            });
        }

        self.init = function () {
            initUploadBtn();
            initFormInputs();
            initWebcamBtn();
            initFormMask();
            initFormSubmit();
        };
    }

    $(function () {
        let page18years = new Page18YearsScrips();
        page18years.init();
    });
})(jQuery);
